import React from "react";
import { Container } from "reactstrap";
import Menu from "../../components/menu/Menu";
import GridQuestionarios from "./components/gridQuestionarios/GridQuestionarios";

export default function Questionarios() {
    return (
        <>
            <Menu />
            <div className="App wrapper">
                <Container>
                    <div className="row">
                        <div className="col-sm-12">
                            <GridQuestionarios />
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}
